import { TableType, TitledTable } from '../../../../../../components'
import { EmploymentCellProps, EmploymentRowProps } from '../../types'

interface EmploymentsTableProps {
  newEmploymentRow: EmploymentRowProps
  cellProps: EmploymentCellProps
}

export const EmploymentsTable = ({
  newEmploymentRow,
  cellProps
}: EmploymentsTableProps) => {
  return (
    <TitledTable
      translationid="pages.ownInfoPage.employment.employments.label"
      tableProps={{
        cellProps,
        type: TableType.Dynamic,
        tableName: 'tyosuhteet',
        formProps: {
          addButtonProps: {
            translationId: 'pages.ownInfoPage.employment.employments.add',
            newRowValue: newEmploymentRow
          }
        }
      }}
    />
  )
}
